import { render, staticRenderFns } from "./indebtedness.vue?vue&type=template&id=6b90ea64&scoped=true&"
import script from "./indebtedness.vue?vue&type=script&lang=js&"
export * from "./indebtedness.vue?vue&type=script&lang=js&"
import style0 from "./indebtedness.vue?vue&type=style&index=0&id=6b90ea64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b90ea64",
  null
  
)

export default component.exports